module.exports = __webpack_public_path__ + "img/odd-loop.4887297a.png";